import { LayoutNavigationBar, LayoutSideDrawer } from './components';

export const Layout = () => (
  <>
    <LayoutNavigationBar />
    <LayoutSideDrawer />
  </>
);
